/** The words a draft in Developer mode shows across the top of the running app (release Plan 3). */
export const DEVELOPER_MODE_STRIP_TEXT = 'Developer mode — running unreleased Zavo code';

/** Only a draft (env 'dev') with Developer mode on. Never Live, whatever the flag says. */
export function showDeveloperModeStrip(cfg: { env?: string; developerMode?: boolean } | null | undefined): boolean {
  return !!cfg && cfg.env === 'dev' && cfg.developerMode === true;
}
